export const SYMBOL_POOL = [
  "Peanutbo",
  "peabnuwo",
  "Pebaion",
  "Epanwuow",
  "Penauwno",
  "Peuabiwp",
  "Peabuwio",
  "OPoiwbai",
];


const BASE_STRING = "peanutbo";
const ALPHABET = "abcdefghijklmnopqrstuvwxyz";

function randInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randChoice<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

function randomChar(exclude?: string): string {
  let ch = randChoice(ALPHABET.split(""));
  if (exclude) {
    while (ch === exclude) ch = randChoice(ALPHABET.split(""));
  }
  return ch;
}

function insertAt(s: string, idx: number, ch: string): string {
  return s.slice(0, idx) + ch + s.slice(idx);
}

function duplicateAt(s: string, idx: number): string {
  return s.slice(0, idx + 1) + s[idx] + s.slice(idx + 1);
}

function substituteAt(s: string, idx: number): string {
  const ch = randomChar(s[idx]);
  return s.slice(0, idx) + ch + s.slice(idx + 1);
}

function transposeAt(s: string, idx: number): string {
  if (s.length < 2) return s;
  if (idx >= s.length - 1) idx = s.length - 2;
  const a = s[idx];
  const b = s[idx + 1];
  return s.slice(0, idx) + b + a + s.slice(idx + 2);
}


function generateCorruptedFromBase(): string {
  const targetLen = randInt(9, 11);
  let s = BASE_STRING;

  while (s.length < targetLen) {
    const op = Math.random() < 0.7 ? "insert" : "duplicate"; 
    const idx = randInt(0, s.length - 1);
    if (op === "insert") {
      const insertIdx = randInt(0, s.length); 
      s = insertAt(s, insertIdx, randomChar());
    } else {
      s = duplicateAt(s, idx);
    }
  }

  const neutralOps = randInt(0, 2);
  for (let i = 0; i < neutralOps; i++) {
    if (Math.random() < 0.6) {
      const idx = randInt(0, s.length - 1);
      s = substituteAt(s, idx);
    } else {
      const idx = randInt(0, Math.max(0, s.length - 2));
      s = transposeAt(s, idx);
    }
  }

  if (s === BASE_STRING) {
    const idx = randInt(0, s.length - 1);
    s = substituteAt(s, idx);
  }

  if (s.length < 7) {
    while (s.length < 7) s = insertAt(s, randInt(0, s.length), randomChar());
  } else if (s.length > 10) {
    while (s.length > 10) {
      const cut = randInt(0, s.length - 1);
      s = s.slice(0, cut) + s.slice(cut + 1);
    }
  }

  return s;
}

export function processTriggerMachineOutput(): [string, string, string] {
  const a = generateCorruptedFromBase();
  const b = generateCorruptedFromBase();
  const c = generateCorruptedFromBase();
  return [a, b, c];
}
